export default function BrandDefinition() {
  return (
    <section className="py-32 px-8 bg-[#181818] border-t border-b border-[#333333]">
      <div className="max-w-[1000px] mx-auto text-center">
        <div className="space-y-12">
          {/* Definition */}
          <div className="space-y-6">
            <h2 className="text-6xl md:text-7xl lg:text-8xl font-black text-white tracking-tight">
              BillPlay
            </h2>
            
            <div className="text-xl md:text-2xl text-gray-400 font-light italic">
              [bil-plei] <span className="text-gray-500">verb</span>
            </div>

            <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed">
              <p>
                <strong className="text-white font-bold">Any circulating medium of exchange</strong>, including coins, paper money, and demand deposits.
              </p>
              
              <p className="text-gray-400 text-base">
                (See also: accumulating a profit or vice versa)
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="w-24 h-px bg-white/20 mx-auto"></div>

          {/* Interpretation */}
          <div className="max-w-2xl mx-auto space-y-6 text-lg text-gray-300 leading-relaxed">
            <p>
              <strong className="text-white font-bold">BillPlay is about movement.</strong> It's about making something from nothing. Turning ambition into action. Style into statement. Hustle into legacy.
            </p>
            
            <p className="text-white font-bold text-2xl">
              It's not just what you wear.<br />
              It's what you represent.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}